import { t } from "../i18n/t";

/**
 * The redesign's wizard rail (guide §3): the stage rail's four-column sibling, as an `<ol>` of plain items
 * (wizard steps are not links — later steps don't exist as addresses yet). `01 · done` / `03 · current` /
 * `04`. When two steps share the current page (5.3: source and destination are one page now), both get the
 * current styling but only the first carries `aria-current="step"`, as drawn in NewMigration.html.
 */
export type WizardRailStep = {
  label: string;
  state: "done" | "current" | "upcoming";
};

export function WizardRail({
  label,
  steps,
}: {
  /** Accessible name for the list (e.g. the `connect.rail_label` key). */
  label: string;
  steps: readonly WizardRailStep[];
}): JSX.Element {
  let currentMarked = false;
  return (
    <ol className="wz" aria-label={label}>
      {steps.map((step, index) => {
        const markCurrent = step.state === "current" && !currentMarked;
        if (step.state === "current") currentMarked = true;
        return (
          <li
            key={step.label}
            className={`wz__step wz__step--${step.state}`}
            aria-current={markCurrent ? "step" : undefined}
          >
            <span className="wz__index">{railIndex(index, step.state)}</span>
            {step.label}
          </li>
        );
      })}
    </ol>
  );
}

function railIndex(index: number, state: WizardRailStep["state"]): string {
  const number = String(index + 1).padStart(2, "0");
  if (state === "done") return `${number} · ${t("stage.done")}`;
  if (state === "current") return `${number} · ${t("stage.current")}`;
  return number;
}
